import { Navigate, createBrowserRouter } from "react-router-dom";
import { Shell } from "./Shell";
import { ChartPage } from "./pages/ChartPage";
import { JobsPage } from "./pages/JobsPage";
import { LoginPage } from "./pages/LoginPage";
import { PickDetailPage } from "./pages/PickDetailPage";
import { PickFormPage } from "./pages/PickFormPage";
import { PicksPage } from "./pages/PicksPage";
import { Placeholder } from "./pages/Placeholder";
import { ScreenerPage } from "./pages/ScreenerPage";
import { WatchlistsPage } from "./pages/WatchlistsPage";
import { RequireAuth } from "./RequireAuth";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: (
      <RequireAuth>
        <Shell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/watchlists" replace /> },
      { path: "watchlists", element: <WatchlistsPage /> },
      { path: "chart", element: <ChartPage /> },
      { path: "screener", element: <ScreenerPage /> },
      { path: "picks", element: <PicksPage /> },
      { path: "picks/new", element: <PickFormPage /> },
      { path: "picks/:id", element: <PickDetailPage /> },
      { path: "picks/:id/edit", element: <PickFormPage /> },
      { path: "jobs", element: <JobsPage /> },
      { path: "*", element: <Placeholder title="Not found" /> },
    ],
  },
]);
